module.exports = __webpack_public_path__ + "img/360205a.png";